import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResumeReferralCopyService {

  //file_url = 'http://192.168.0.147:8021/api/' + 'Parsing/';
  api_url = environment.SERVER_URL + 'Resumes/';
  file_url = environment.SERVER_URL + 'Parsing/';
  //file_url = environment.SERVER_URL + 'Parsing/';
  constructor(
    private http: HttpClient
  ) { }
  getResumeDetails(requirement_id, referrer_id) {
    return this.http.get(this.api_url + 'Master', { params: { lng_id: '1', requirement_id: requirement_id, referrer_id: referrer_id || 0 } });
  }
  saveResumeDetails(referrer_id, obj) {
    return this.http.post(this.api_url + 'Data', obj, { params: { referrer_id: referrer_id || 0 } });

  }
  saveFile(file) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(this.file_url + 'XMLToJSON', file, { headers: undefined });

  }
}
